import { render, staticRenderFns } from "./UserDealOrderService.vue?vue&type=template&id=06254dbd&scoped=true&"
import script from "./UserDealOrderService.vue?vue&type=script&lang=js&"
export * from "./UserDealOrderService.vue?vue&type=script&lang=js&"
import style0 from "./UserDealOrderService.vue?vue&type=style&index=0&id=06254dbd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06254dbd",
  null
  
)

export default component.exports